import React from 'react';
import './index.scss';
import { showModal } from '@/components/Modal';
import { message, Radio } from 'antd';
import { request } from '@/fetch/core';
import { Method } from '@/fetch/core/util';
import { HttpStatusCode } from '@/fetch/core/constant';
import { useSelector } from 'react-redux';
import { RootState } from '@/redux/store';
import { cloudFetchConfig } from '@/utils/util';
import { sendGlobalEvent } from '@/utils/emit';
import { EventName, CLSTAG } from '@/utils/constant';

enum TakeOverSettingItem {
  speedLimit = 'speedLimit',
}

const setContent = new Map([
  [
    { value: TakeOverSettingItem.speedLimit, label: '速度限制' },
    [
      {
        value: 5,
        label: '5km/h',
      },
      {
        value: 10,
        label: '10km/h',
      },
      {
        value: 15,
        label: '15km/h',
      },
      {
        value: 20,
        label: '20km/h',
      },
      {
        value: 25,
        label: '25km/h',
      },
    ],
  ],
]);

const TakeoverSetting = () => {
  const cockpitNumber = useSelector(
    (state: RootState) => state.newCommon?.cockpitNumber
  );
  const userName = useSelector(
    (state: RootState) => state.login?.userInfo?.userName
  );

  const getUserConfig = async () => {
    const res = await request({
      ...cloudFetchConfig('/monitor/web/user/getUserDriveConfig'),
      method: Method.POST,
      body: {
        userName: userName,
      },
    });
    if (res.code === HttpStatusCode.Success) {
      return { [TakeOverSettingItem.speedLimit]: res?.data?.speedLimit ?? 15 };
    } else {
      return { [TakeOverSettingItem.speedLimit]: 15 };
    }
  };

  const saveUserConfig = async (info: any, cb: AnyFunc) => {
    request({
      ...cloudFetchConfig('/monitor/web/user/saveUserDriveConfig'),
      method: Method.POST,
      body: {
        ...info,
        userName: userName,
        cockpitNumber: cockpitNumber,
      },
    }).then((res) => {
      if (res.code === HttpStatusCode.Success) {
        message.success('设置成功');
        sendGlobalEvent(EventName.CHANGE_USER_CONFIG);
        cb();
      } else {
        message.error(res?.message);
      }
    });
  };

  const changeSetInfo = async () => {
    const info: any = await getUserConfig();
    showModal({
      title: '接管设置',
      width: 800,
      footer: {
        showCancel: true,
        showOk: true,
        cancelText: '取消',
        okText: '确定',
        cancelFunc: (cb) => cb(),
        okFunc: (cb) => {
          saveUserConfig(info, cb);
        },
      },
      content: (
        <>
          {Array.from(setContent.keys()).map((v) => {
            return (
              <div className="set-content" key={v.value}>
                <div className="field-name">
                  <i></i>
                  {v.label}
                </div>
                <Radio.Group
                  options={setContent.get(v)}
                  defaultValue={info[v.value]}
                  onChange={(e) => {
                    info[v.value] = e.target.value;
                  }}
                />
              </div>
            );
          })}
        </>
      ),
    });
  };
  return (
    <>
      <li
        className="btn-item takeover-setting"
        clstag={CLSTAG.TakeOver_Setting}
        onClick={() => {
          changeSetInfo();
        }}
      >
        <i>接管设置</i>
      </li>
    </>
  );
};

export default React.memo(TakeoverSetting);
